"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSizeLimitError = void 0;
class TreeSizeLimitError extends Error {
    code = 422;
    name = 'TreeSizeLimitError';
    currentTreeSize;
    constructor() {
        super('Tree size exceeds the allowed limit.');
        Error.captureStackTrace(this, TreeSizeLimitError);
    }
}
exports.TreeSizeLimitError = TreeSizeLimitError;
//# sourceMappingURL=tree-size-limit-error.js.map